import { Card, CardContent, Typography } from "@material-ui/core";
import React, { CSSProperties, ReactNode } from "react";

type MobilePagedCardProps = {
  title: string;
  key: string;
  style: CSSProperties;
  children: ReactNode;
};

const MobilePagedCard = (props: MobilePagedCardProps) => {
  return (
    <Card key={props.key} style={props.style} square>
      <CardContent>
        <Typography
          className="mobile-paged-card"
          style={{
            fontSize: "18px",
            paddingBottom: "2em",
            textAlign: "center",
          }}
        >
          <strong>{props.title}</strong>
        </Typography>
        {props.children}
      </CardContent>
    </Card>
  );
};

export default MobilePagedCard;
